import { IObservableArray } from "mobx";
import { CollectionName, GenomeInList, PaginationMetadata } from "../api";

export type GenomesPageData = {
  genomes: IObservableArray<GenomeInList>;
  loading: boolean;
  pagination: PaginationMetadata;
  error: boolean;
};

export function constructGenomeDisplayName(
  genome: GenomeInList,
  collectionName: CollectionName | null
): string {
  // There is divergent logic associated with the display of taxonomic names for bacteria vs. viruses
  // We always want to display bacterial species name, but viral species classifications are too nebulous
  // In the event of a virus, we should display the taxon name even if it is a child of the species

  const speciesTaxon = genome.species_taxon;

  if (collectionName && collectionName === "virology" && genome.taxon_name) {
    return cleanTaxaName(genome.taxon_name);
  } else if (speciesTaxon) {
    return cleanTaxaName(genome.taxon_name);
  }

  return "";
}

export function cleanTaxaName(name: string | undefined | null): string {
  if (name == null) {
    return "";
  }
  return name.replace("[", "").replace("]", "");
}
